import { render, staticRenderFns } from "./SessionScheduleBlock.vue?vue&type=template&id=59a51a8b&scoped=true&"
import script from "./SessionScheduleBlock.vue?vue&type=script&lang=js&"
export * from "./SessionScheduleBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a51a8b",
  null
  
)

export default component.exports